<template>
    <div id="listCases">
        <template v-if="cantAccessPageCase === true">
            <div class="container-fluid xyz">
                <div :class="'page-header-top-container'+titleMargin">
                    <div class="page-name color-71aa3f">{{casePageData.pageTitle}}</div>
                    <template v-for="(permission, index) in permissionsCase">
                        <button title="Add" v-if="permission.name == 'can_add_new_case'" type="submit" class="btn general-button btn-primary icon-btn" v-on:click.prevent="addCases">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                        <button title="Import" v-if="permission.name == 'can_import_cases_data' && casePageData.cus_id == 0" type="button" class="btn general-button btn-primary icon-btn" data-toggle="modal" data-target="#CasedefaultModal">
                            <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                        </button>
                        <button title="Export" v-if="permission.name == 'can_export_cases_data'" type="button" id="exportCase" class="btn general-button btn-primary icon-btn" 
                                v-on:click="exportCases($event)">
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>
                        </button>
                    </template>
                    <div class="btn-group pull-right">
                        <button type="button" class="btn_all_case btn general-button btn-primary" v-on:click="allClickCase()">All</button>
                        <button type="button" class="btn_my_case btn general-button btn-secondary" v-on:click="myClickCase()">My Self</button>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <vue-good-table class="casesTable"
                                        ref="listCasesTable"
                                        mode="remote"
                                        title="Cases"
                                        @on-page-change="onPageChangeCase"
                                        @on-selected-rows-change="selectionChangedCase"
                                        @on-column-filter="onColumnFilterCase"
                                        @on-per-page-change="onPerPageChangeCase"
                                        @on-sort-change="onSortChangeCase"
                                        :totalRows="totalRecordsCase"
                                        :columns="columnsCase"
                                        :rows="rowsCase"
                                        :selectOptions="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                        }"
                                        :pagination-options="{
                                        enabled: true,
                                        mode: 'pages',
                                        pageLabel: 'Page',
                                        position: 'bottom',
                                        perPage: serverParamsCase.perPage,
                                        setCurrentPage: serverParamsCase.setCurrentPage,
                                        perPageDropdown: serverParamsCase.perPageDropdown,
                                        dropdownAllowAll: false,
                                        }"

                                        :search-options="{
                                        enabled: false,
                                        }">
                                        <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm" v-if="totalRecordsCase > 0">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParamsCase.perPage"
                                                      @change="changedValueCase"
                                                      @input="changedValueCaseCustomPerPageCase()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="serverParamsCase.perPageDropdown"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRowsCase}} of {{totalRecordsCase}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParamsCase.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickCase(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParamsCase.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickCase(Number(serverParamsCase.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberListCase() < displayPageCase">
                                                    <template v-for="(n, index) in pageNumberListCase()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsCase.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickCase(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParamsCase.page) <= pageCompareCase">
                                                        <template v-for="(n, index) in displayPageCase">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsCase.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickCase(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParamsCase.page) >= (pageNumberListCase() - (pageCompareCase-1))">
                                                        <template v-for="(n, index) in pageNumberListCase()">
                                                            <template v-if="n > (pageNumberListCase() - displayPageCase)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsCase.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickCase(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberListCase()" v-if="(n >= (Number(serverParamsCase.page) - (pageCompareCase -1))) && (n <= (Number(serverParamsCase.page) + (pageCompareCase -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsCase.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickCase(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParamsCase.page) == pageNumberListCase()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickCase(Number(serverParamsCase.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParamsCase.page) == pageNumberListCase()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListCase()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClickCase(pageNumberListCase())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListCase()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>                                
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input @keyup.enter="jumpToPageInCase" v-model="jumpToPageCase" type="text" class="form-control form-control-sm" name="jumpToPageCase" id="jumpToPageCase" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rowsCase">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'">
                                        <!--class="btn btn-xs general-button btn-primary"-->
                                        <template v-if="permission.name == 'can_add_new_case'" v-for="(permission, index) in permissionsCase">
                                            <router-link title='Edit case' v-if="props.row.created_by == loginIDCase" class="btn edit-btn-vvg" v-bind:to="{name: 'CaseUpdate',params:{id:props.row.id,from:casePageData.cus_id}}"><i class="fa fa-pencil-square-o"></i></router-link>
                                        </template>
                                        <template v-if="permission.name == 'can_see_case_view'" v-for="(permission, index) in permissionsCase">
                                            <router-link title='View case details' class="btn edit-btn-vvg" v-bind:to="{name: 'CaseView',params:{id:props.row.id,from:casePageData.cus_id}}"><i class="fa fa-eye"></i></router-link>
                                        </template>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <div slot="selected-row-actions" slot-scope="computed" class="">
                                {{computed.selectedRows}}
                                <template v-if="permission.name == 'can_add_new_case'" v-for="(permission, index) in permissionsCase">
                                    <button title='Delete case' v-on:click="onDeleteClickCase" class="btn general-button btn-success waves-effect">Delete</button>
                                </template>
                            </div>

                        </vue-good-table>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="CasedefaultModal" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Import Cases From Excel</h4>
                        </div>
                        <form class="form-inline" id="importTasksform" enctype="multipart/form-data">
                            <div class="modal-body">
                                Select Excel File to Import Cases
                                <label class="myLabel btn general-button btn-info m-r-20">
                                    <input type="file" name="excl_file" accept=".xlsx,.xls" id="upload" ref="filesCase" v-on:change="handleFilesUploadCase()"/>
                                    <span>Select File ...</span>
                                </label>
                                <div class="form-group">
                                    <label id="errorMsg" class="error"></label><br>
                                </div>
                                <a id ="demourl" href="demoUrl" target="_blank" class="btn general-button btn-info mt-2">
                                    Download Demo
                                </a>
                            </div>
                            <div class="modal-footer">
                                <button type="button" v-on:click="importCases($event);" class="btn general-button btn-success">Import</button>
                                <button type="button" class="btn general-button btn-danger" data-dismiss="modal">Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="CasesExportModel" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title" id="defaultModalLabel">Import Cases From Excel</h4>
                        </div>
                        <div class="modal-body">
                            Case's Exported File is ready to download Please click <a type="button" id="downloadButton" target="_blank" href = "" ><label style="cursor: pointer;" class="font-bold col-pink">DOWNLOAD</label></a> to download the file.
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn general-button btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>


    // import { headers } from "../config";
    import {list_customerUrl, configs} from '../../config';
    import SessioMixin from '../../mixins/sessionmixin';
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {listCustomer} from '../../config';
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');

    Vue.use(VueGoodTable);

    export default {
        name: "listCases",
        mixins: [SessioMixin],
        props: {
            casePageData: '',
        },
        data: () => ({
                titleMargin: '',
                displayPageCase: 7,
                pageCompareCase: 0,
                paginationDisplayRowsCase: '',
                jumpToPageCase: 0,

                loginIDCase: 0,
                permissionsCase: [],
                cantAccessPageCase: true,
                messageCase: 'all',
                exportFilteredFlagCase: false,
                firstLoadCase: 0,
                filesCase: [],
                columnsCase: [
                    {
                        label: 'Case ID',
                        field: 'id',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "ID", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created By',
                        field: 'created_first_name',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    // {
                    //     label: 'Collector',
                    //     field: 'collector_user_full_name',
                    //     filterable: true,
                    //     sortable: false,
                    //     filterOptions: {
                    //         enabled: true, // enable filter for this column
                    //         placeholder: "Collector", // placeholder for filter input
                    //         filterValue: '', // initial populated value for this filter
                    //         trigger: "enter" //only trigger on enter not on keyup
                    //     }
                    // },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'customer_firstname',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Assigned Internal User',
                        field: 'assigned_internal_user',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Assigned Internal User", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Status", // placeholder for filter input
                            filterDropdownItems: ['Open', 'In Progress', 'Resolved', 'Closed'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Priority',
                        field: 'priority',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Select Priority", // placeholder for filter input
                            filterDropdownItems: ['Low', 'Normal', 'High'], // dropdown (with selected values) instead of text input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Reported On',
                        field: 'created_at',
                        filterable: true,
                        sortable: false,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "From | To", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Action',
                        field: 'action',
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '106px',
                    }

                ],
                rowsCase: [],
                totalRecordsCase: 0,
                serverParamsCase: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'created_at',
                        type: 'desc',
                    }/*[
                     {
                     field: 'priority',
                     type: 'asc',
                     },
                     {
                     field: 'created_at',
                     type: 'desc',
                     },
                     ]*/,
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                    perPageDropdown: [],
                },
            }),

        mounted: function () {
            var app = this;
            var initial = process.env.ROOT_API;
            initial = initial.replace('/v1', '');
            $("#demourl").attr("href", initial + '/demo/Cases.xlsx');
            app.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                this.loginIDCase = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            this.jumpToPageCase = this.serverParamsCase.page;
            this.pageCompareCase = Math.ceil(this.displayPageCase / 2);
            $("#jumpToPageCase").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    app.jumpToInputPageCase(app.jumpToPageCase);
                }
            });
            if (app.casePageData.is_part == 1) {
                app.titleMargin = " pt-0";
            }
            if (this.casePageData.cus_id > 0) {
                this.loadFilters('menucasescustomer', this.columnsCase, this.serverParamsCase, 'casesTable');
            } else {
                this.loadFilters('menucases', this.columnsCase, this.serverParamsCase, 'casesTable');
            }
            this.serverParamsCase.perPage = this.casePageData.perPage;
            for (var i = this.casePageData.perPage; i < 100; ) {
                this.serverParamsCase.perPageDropdown.push(i);
                if (this.casePageData.perPage < 5) {
                    i = i * 5;
                } else {
                    i = i * 2;
                }
            }
            this.serverParamsCase.perPageDropdown.push(100);
            this.serverParamsCase.perPageDropdown.push(200);
            this.serverParamsCase.perPageDropdown.push(500);
            this.loadCases();
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                app.getPermissionsCase();
            }
            if (app.casePageData.cus_id > 0) {
                app.columnsCase['2'].filterOptions.enabled = false;
                app.columnsCase['3'].filterOptions.enabled = false;
            }
        },
        methods: {
            /* Custome pagination Methods started */
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            jumpToPageInCase: function (e) {
                let self = this;
                self.jumpToInputPageCase(self.jumpToPageCase)
            },
            changedValueCase: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPageCase: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListCase()) {
                    pageNumber = self.pageNumberListCase();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageCase).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickCase(pageNumber);
            },
            onPerticularPageClickCase: function (pageNumber) {
                var self = this;
                self.serverParamsCase.page = pageNumber;
                self.jumpToPageCase = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoadCase != 1 && self.jumpToPageCase != 1) {
                    self.loadCases();
                } else if(self.firstLoadCase == 1 && self.jumpToPageCase >=1) {
                    self.loadCases();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberListCase: function () {
                var self = this;
                var totalRecord = self.totalRecordsCase;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParamsCase.perPage;
                    count++;
                }
                return count;
            },
            changedValueCaseCustomPerPageCase: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoadCase != 1) {
                    self.jumpToInputPageCase(self.serverParamsCase.page);
                    self.loadCases();
                }
                /* Single Backend Call on page load end */
            },
            /* Custome pagination Methods End */
            getPermissionsCase: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagCase = false;
                        if (data.status == 'success') {
                            self.cantAccessPageCase = false;
                            self.permissionsCase = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissionsCase.length > 0) {
                                for (var i = 0; i < self.permissionsCase.length; i++) {
                                    if (self.permissionsCase[i].name == 'can_see_case_list') {
                                        self.cantAccessPageCase = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPageCase = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            updateParamsCase(newProps) {
                this.serverParamsCase = Object.assign({}, this.serverParamsCase, newProps);
            },
            //
            onPageChangeCase(params) {
                this.updateParamsCase({page: params.currentPage});

                this.loadCases();
            },
            //
            onPerPageChangeCase(params) {
                this.updateParamsCase({perPage: params.currentPerPage});
                this.totalRecordsCase = this.totalRecordsCase;
                this.loadCases();
            },

            onColumnFilterCase(params) {
                this.updateParamsCase(params);
                {
                    field: ('id');
                    field: ('collector_user_full_name');
                    field: ('assigned_internal_user');
                    field:('status');
                    field:('priority');
                    field:('cusid');
                    field:('customer_firstname');
                    field:('created_at');
                }
                ;
                this.serverParamsCase.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamsCase));
                var filters = filtersPr.columnFilters;

                if (this.firstLoadCase == 1 || filters.id || filters.collector_user_full_name || filters.assigned_internal_user
                        || filters.status || filters.priority || filters.cusid || filters.customer_firstname || filters.created_at) {
                    this.loadCases();
                }

            },
            selectionChangedCase() {

                var self = this;
                // console.log( this.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            allClickCase: function () {
                var self = this;
                self.messageCase = 'all';
                self.loadCases();
            },
            myClickCase: function () {
                var self = this;
                self.serverParamsCase.page = 1;
                self.jumpToPageCase = 1;
                self.messageCase = 'my';
                self.loadCases();
            },
            onSortChangeCase(params) {
                this.updateParamsCase({
                    sort: {
                        type: params.sortType,
                        field: this.columnsCase[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                this.loadCases();
            },
            loadCases: function () {
                var self = this;
                self.serverParamsCase.setCurrentPage = self.serverParamsCase.page;
                if (self.messageCase == 'my') {
                    self.toggleButtons(self.messageCase, 'btn_my_case', 'btn_all_case');
                } else {
                    self.toggleButtons(self.messageCase, 'btn_all_case', 'btn_my_case');
                }
                if (self.casePageData.cus_id > 0) {
                    var fields = {
                        page: self.serverParamsCase.page,
                        perPage: self.serverParamsCase.perPage,
                        filters: self.serverParamsCase.columnFilters,
                        messageData: self.messageCase,
                        sort: self.serverParamsCase.sort,
                        exportFiltered: self.exportFilteredFlagCase,
                        custid: self.casePageData.cus_id
                    };
                    self.storeFilters('menucasescustomer', self.serverParamsCase, false);
                } else {
                    var fields = {
                        page: self.serverParamsCase.page,
                        perPage: self.serverParamsCase.perPage,
                        filters: self.serverParamsCase.columnFilters,
                        messageData: self.messageCase,
                        sort: self.serverParamsCase.sort,
                        exportFiltered: self.exportFilteredFlagCase
                    };
                    self.storeFilters('menucases', self.serverParamsCase, false);
                }

                this.firstLoadCase = 1;
                // console.log(self.serverParamsCase.perPage);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/case/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.exportFilteredFlagCase = false;
                        if (data.message == 'success' || data.message == 'error') {
                            self.rowsCase = data.content.row;
                            self.totalRecordsCase = data.content.totalRecords;
                            self.showHidePagination("casesTable", self.totalRecordsCase);
                            self.filteredFlag = false;
                            self.jumpToPageCase = self.serverParamsCase.page;
                        }
                        if (data.message == "success export") {
                            //console.log(data.content.web);
                            $('#exportCase').html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                            $('#exportCase').prop("disabled", false);
                            self.downloadFile(data.content.web);
                            // location.href = data.content.web;
                        }
                        self.paginationDisplayRowsCase = self.getRecords(self.serverParamsCase.page, self.serverParamsCase.perPage, self.totalRecordsCase);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },
            addCases() {
                var self = this;
                self.$router.push('/case/create/' + self.casePageData.cus_id)
            },
            updateCase() {

                var self = this;
                // self.$router.push("/addtask");
                self.$router.push("/case/create");
            },
            onDeleteClickCase() {
                var self = this;
                var selectedCases = self.$refs['listCasesTable'].selectedRows;
                var casesArr = [];
                for (var i = 0; i < selectedCases.length; i++) {
                    casesArr.push(this.$refs['listCasesTable'].selectedRows[i].id);
                }
                //console.log(casesArr);
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                                )
                        $.ajax({
                            url: process.env.ROOT_API + "/case/removemultiple",
                            type: "POST",
                            data: 'ids=' + casesArr,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                if (data.code == 200) {
                                    console.log(data.message);
                                    self.rowsCase = data.content.row;
                                    self.totalRecordsCase = data.content.totalRecords;
                                    self.loadCases();
                                }
                            },
                            error: function (jqXHR, exception) {
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    self.error = jqXHR.responseJSON.message;
                                }
                            }

                        });
                    }
                })
            },
            importCases(e) {
                var self = this;
                $(e.target).html('');
                $(e.target).html('Importing...');
                $(e.target).prop("disabled", true);
                var formData = new FormData();
                for (var i = 0; i < self.filesCase.length; i++) {
                    let file = self.filesCase[0];
                    //console.log(file);
                    formData.append('excl_file', file);
                }
                //console.log(formData);
                $.ajax({
                    url: process.env.ROOT_API + "/case/import",
                    type: "POST",
                    data: formData,
                    processData: false,
                    contentType: false,
                    dataType: 'json',
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    success: function (data) {

                        if (data.status == "success") {
                            $("#errorMsg").html('');
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            /*$("#errorMsg").html(data.message);*/
                            self.loadCases();
                            self.hideModelCase();
                            var messageType = 'success';
                            var messageTitle = 'Success';
                            if (data.import > 0) {
                                messageType = 'success';
                                messageTitle = 'Success';
                            } else {
                                messageType = 'info';
                                messageTitle = 'Warning';
                            }
                            Swal.fire({
                                type: messageType,
                                title: messageTitle,
                                html: data.message + '<br>' + data.messageSkipRecords,
                                showConfirmButton: true,
                            });

                        } else {
                            $(e.target).html('');
                            $(e.target).html('Import');
                            $(e.target).prop("disabled", false);
                            $("#errorMsg").html(data.message);
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                                $("#errorMsg").html(err);
                            }
                        }

                    },
                    error: function (jqXHR, exception) {
                        $(e.target).html('');
                        $(e.target).html('Import');
                        $(e.target).prop("disabled", false);
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.errorMsg = jqXHR.responseJSON.message;
                        }
                    }
                });
                // self.$router.push("/addtask");
                //self.$router.push("/task/create");
            },
            hideModelCase() {
                $('#CasedefaultModal').modal('hide');
                return false;
            },
            downloadFile: function (href) {
                if ($('#DynDownloadAnchor').length) {
                    $('#DynDownloadAnchor').remove();
                }
                var anchor = document.createElement('a');
                anchor.id = "DynDownloadAnchor";
                anchor.style.display = "none";
                anchor.href = href;
                anchor.download = href;
                document.body.appendChild(anchor);
                anchor.click();
            },
            handleFilesUploadCase: function () {
                /*
                 Get the uploaded files from the input.
                 */
                var self = this;
                let uploadedFiles = "";
                uploadedFiles = self.$refs.filesCase.files;
                //console.log(uploadedFiles);
                /*
                 Assign the uploaded file to the files array
                 */
                /*this.filesCase.pop();*/
                for (var i = 0; i < uploadedFiles.length; i++) {
                    self.filesCase = [uploadedFiles[i]];
                }
                /*this.getImagePreviews();*/
            },
            exportCases(e) {
                var self = this;
                self.exportFilteredFlagCase = true;
                //console.log(self.exportFilteredFlagCase);
                // console.log(self.filteredFlag);
                if (self.exportFilteredFlagCase == true) {
                    //console.log("True");
                    self.loadCases();
                } else {
                    //change button 
                    $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>...');
                    $(e.target).prop("disabled", true);
                    $.ajax({
                        url: process.env.ROOT_API + "/case/export",
                        type: "GET",
                        data: {type: 'xlsx'},
                        //processData: false,
                        //contentType: false,
                        dataType: 'json',
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("api_token"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        success: function (data) {
                            if (data.status == "success") {
                                self.downloadFile(data.content.web);
                                // location.href = data.content.web;
                                /*$("#downloadButton").attr("href", data.content.web);
                                 $('#CasesExportModel').modal('show');*/
                                $(e.target).html('<i class="fa fa-cloud-download" aria-hidden="true"></i>');
                                $(e.target).prop("disabled", false);
                                //alert('success');
                                /*alert(data.message);*/
                                /*$("#errorMsg").html(data.message);*/
                            } else {
                                $("#errorMsg").html(data.message);
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                }
                            }

                        },
                        error: function (jqXHR, exception) {
                            if (jqXHR.status == 0) {
                                self.errorMsg = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('api_token');
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }

                                self.errorMsg = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
                // self.loadTask();
            }
        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/cases/CaseListComponent.vue